<template>
  <tippy
    placement="top"
    theme="wila"
    animation="fade"
    arrow="true"
    allow-html="true"
    interactive="true"
    max-width="440px"
  >
    <template #trigger>
      <div class="c-facet__tooltip">
        <i class="far fa-info-circle text-muted"></i>
      </div>
    </template>

    <div class="tooltip__body">
      <div class="tooltip__body--image">
        <img
          v-if="tooltip.imageName"
          :src="
            `${tooltip.imageName}?entropycrop=100&height=130&width=120&mode=boxpad&bgcolor=fff&format=webp`
          "
          :alt="tooltip.title"
          loading="lazy"
          height="130px"
          width="120px"
        />
      </div>

      <div class="tooltip__body--content">
        <span class="tooltip__body--title">
          {{ tooltip.title }}
        </span>

        <p class="tooltip__body--text" v-html="tooltip.description"></p>

        <a
          v-if="tooltip.url"
          class="tooltip__body--link p-0 btn btn-white with-icon"
          :href="tooltip.url"
          :title="tooltip.title"
          target="_blank"
        >
          {{ getProductOverviewTranslations['ProductsOverview.MoreInfo'] }}
        </a>
      </div>
    </div>
  </tippy>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Tooltip',
  props: {
    tooltip: {
      type: Object,
      required: true,
      title: {
        type: String,
        default: undefined
      },
      description: {
        type: String,
        default: undefined
      },
      imageName: {
        type: String,
        default: undefined
      },
      url: {
        type: String,
        default: undefined
      }
    }
  },
  computed: {
    ...mapGetters('translations', ['getProductOverviewTranslations'])
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.tippy-tooltip.wila-theme > .tippy-arrow {
  border-top-color: $white;
  border-bottom-color: $white;
}

.tippy-tooltip {
  background-color: $white;
  color: $body-color;
  padding: 20px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
  border-radius: 0;
  display: flex;

  .tippy {
    &-content {
      padding: 0;
    }
  }

  .tooltip {
    &__body {
      text-align: left;
      display: flex;
      gap: 20px;

      &--content {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        align-items: flex-start;
        justify-content: center;
      }

      &--title {
        font-weight: 700;
        font-size: rem(16);
      }

      &--text {
        font-size: rem(14);
        font-weight: 400;

        margin: {
          bottom: unset;
        }
      }

      &--link {
        color: $primary;
        font-size: rem(16);
        font-weight: 700;
        display: inline-block;
        border: none;

        margin: {
          top: 10px;
          bottom: 5px;
        }
      }
    }
  }
}
</style>
